module.exports = __webpack_public_path__ + "static/siderail1-b9bc60c0c11b1b49849d01addbf202d4.jpg";